<template>
	<div>
		<div style="height:450px;border:1px solid #E6E7E9">
			<div style="height:20px;background-color: #F4F5FA;padding:12px">
				<span style="font-size:15px;font-weight:700">合同签订发起详情</span>
			</div>
			<div style="height:1px;background-color:#E6E7E9"></div>

			<div style="margin:40px;font-weight:700">
				<div style="height:60px">组织架构：
					<div style="color: #7a7a7a; margin-top: 5px;">{{ $globals.group_name + '/' + from.range}}</div>
				</div>
				<div style="height:60px">起止时间：
					<div style="color: #7a7a7a; margin-top: 5px;">
						{{from.start_stop_date[0] + "—" + from.start_stop_date[1]}}
					</div>
				</div>
				<div style="height:60px">岗位：
					<div style="color: #7a7a7a; margin-top: 5px;">
						<span v-for="item in from.postList" :key="item.id">{{item.post_name}},&nbsp;&nbsp;</span>
					</div>
				</div>
				<div>合同模板：
					<div style="color: #000000; margin: 10px 0;">
						<div style="display: inline-block; width: 80px; height: 30px; border: 1px solid #e5e5e5; border-radius:5px; margin-left: 5px;"
							v-for="item in from.templateList" :key="item.id">
							<el-row>
								<el-col :span="12" style="text-align: right;"><span
										style="line-height: 30px;">{{item.template_name}}</span></el-col>
								<el-col :span="10" :offset="2"><img src="../../../assets/icon/下载模板.png"
										style="margin-top: 6px;" /></el-col>
							</el-row>
						</div>
					</div>
				</div>
				<div style="height:60px">状态：
					<div style="color: #30c7a9; margin-top: 5px;" v-show="from.state === '1'">
						已生效
					</div>
					<div style="color: #ff9435; margin-top: 5px;" v-show="from.state === '0'">
						未生效
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["from"]
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// HtqdFq_edit.vue?75241343